var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin-manage"},[_c('Header'),_c('Sidebar',{attrs:{"sidebars":_vm.adminSidebars}}),_c('div',{staticClass:"admin-manage__container"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }